module.exports = __webpack_public_path__ + "static/media/volume_sky.94782cc9.svg";